import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { StorageService } from 'src/app/providers/storage.service';
import { PaymentType } from 'src/app/shared/constants/payment-type.enum';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-transaction-info',
  templateUrl: './all-transaction-info.component.html',
  styleUrls: ['./all-transaction-info.component.scss']
})
export class AllTransactionInfoComponent implements OnInit {
  @ViewChild('dateTemplate', { static: true })
  dateTemplateRef!: TemplateRef<HTMLElement>;
  @ViewChild('costTemplate', { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  tableColumns: ITableColumnHeader[] = [];
  transactionList: any[] = [];

  constructor(private _storageService: StorageService) { }

  ngOnInit(): void {
    this.tableColumns = [
      {
        columnName: 'date',
        columnProperty: 'creationDate',
        columnTemplate: this.dateTemplateRef
      },
      {
        columnName: 'transaction type',
        columnProperty: 'paymentType'
      },
      {
        columnName: 'transaction id',
        columnProperty: 'paymentRef'
      },
      {
        columnName: 'Pack name',
        columnProperty: 'planName'
      },
      {
        columnName: 'subscription start',
        columnProperty: 'fromDate',
        columnTemplate: this.dateTemplateRef
      },
      {
        columnName: 'subscription end',
        columnProperty: 'toDate',
        columnTemplate: this.dateTemplateRef
      },
      {
        columnName: 'paid amount',
        columnProperty: 'totalCost',
        columnTemplate: this.costTemplateRef
      }
    ];

    const storedSubscriptionData = JSON.parse(this._storageService.getValueFromAppStorage(SM_CONSTANTS.USER_SUBSCRIPTION_DATA));
    // console.log(storedSubscriptionData);
    this.transactionList = storedSubscriptionData.transInfo ?  storedSubscriptionData.transInfo  : []
    // this.transactionList = storedSubscriptionData.transInfo;
    this.transactionList.forEach(list =>{
      list.paymentType = PaymentType[list.paymentType];
    });
  }

}
